<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  width: 100%;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
/* .icon-product:before {
  color: #333333;
}
.icon-contact:before {
  color: #333333;
} */
/* 弹框位置 */
/* 消除下划线 */
</style>
